<style scoped>
  .form-control{
    border: none;
    background: #eee;
    font-size: 1.2em;
    color: #000;
  }

  textarea{
    resize: none;
  }

  .repeat-mode{
    display: inline-flex;
    align-items: center;
    margin-right: 1em;
    border: 2px solid #e5e5e5;
    border-radius: 6px;
    padding: 0.25em 1em 0.4em 0.8em;
  }

  .repeat-mode.selected{
    background: #e8e8e8;
  }

  .repeat-mode input{
    display: inline-block;
    margin-right: 0.6rem;
  }
</style>

<template>
  <div class="app mt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div style="width: 600px">
          <div class="card p-4">
            <div class="card-body">
              <form @submit="createReminder">
                <h1>Schedule Reminder</h1>

                <!-- <p :class="{'text-muted': !authFailed, 'text-danger': authFailed}">
                  {{ !authFailed ? 'Sign In to your account' : 'Wrong username or password' }}
                </p> -->

                <div class="form-group mt-3 mb-3">
                  <label for="title">Title</label>
                  <input id="title" v-model="title" type="text" class="form-control" required />
                </div>
                
                <div class="form-group mb-3">
                  <label for="type">Reminder Type</label>
                  
                  <div>
                    <label v-for="(reminderType, index) in ['Loan Repayment']"
                      :key="index"
                      class="repeat-mode" :class="{'selected': type === reminderType}"
                      :for="'type' + index">
                      <input
                        :id="'type' + index"
                        name="type"
                        type="radio"
                        :value="reminderType"
                        v-model="type"
                      />
                      {{ reminderType }}
                    </label>

                    <span
                      v-if="formHasError && !type"
                      class="hel-block text-danger">
                      Choose at least one option
                    </span>
                  </div>
                </div>
                
                <div class="form-group mb-3">
                  <label for="repeatMode">Repeat Mode</label>
                  <div>
                    <label v-for="(mode, index) in ['Once', 'Monthly', 'Weekly', 'Daily']"
                      :key="index"
                      class="repeat-mode" :class="{'selected': repeatMode === mode}"
                      :for="'repeatMode' + index">
                      <input
                        :id="'repeatMode' + index"
                        name="repeatMode"
                        type="radio"
                        :value="mode"
                        v-model="repeatMode"
                      />
                      {{mode}}
                    </label>

                    <span
                      v-if="formHasError && !repeatMode"
                      class="hel-block text-danger">
                      Choose at least one option
                    </span>
                  </div>
                </div>
                
                <div class="form-group mb-3">
                  <label for="repeatOn">
                    {{ repeatMode === "Once" ? "Reminder Date" : "Repeat On" }}
                  </label>

                  <input v-if="repeatMode === 'Once'" style="max-width: 200px" id="repeatOn" 
                    v-model="repeatOn" 
                    type="date" 
                    :min="new Date().toISOString().split('T')[0]"
                    class="form-control" required 
                  />

                  <select v-else
                    style="max-width: 200px" id="repeatOn" 
                    class="form-control" 
                    required
                    v-model="repeatOn">

                    <option value="">
                      Pick 
                      <span v-if="repeatMode === 'Monthly'">Day of Month</span>
                      <span v-if="repeatMode === 'Weekly'">Week Day</span>
                      <span v-if="repeatMode === 'Daily'">Time</span>
                    </option>
                    
                    <option v-for="day in repeatOnChoices" :key="day" :value="day">
                      {{ day }}
                    </option>
                  </select>
                </div>
                
                <div class="form-group mb-4">
                  <label for="description">The Message</label>
                  <textarea
                    id="description"
                    class="form-control"
                    v-model="message"
                    rows="5"
                    required />
                </div>

                <button type="submit" :class="{disabled: creatingReminder}" class="btn btn-lg btn-block btn-primary px-4">
                  {{ !creatingReminder ? 'SUBMIT' : 'Please Wait...' }}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  // dayOfMonth 1 - 31,  // monthly
  // dayOfWeek 1 - 7,  // weekly
  // hour 0 - 23, // daily
  const daysOfMonth = Array.from(Array(31)).map((_, index) => index + 1);
  const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const hoursChoices = Array.from(Array(24)).map((_, index) => `${index <= 9 ? '0' : ''}${index}` + ' : 00');
  // const minuteChoices = Array(61).map((_, index) => index);

  export default {
    name: 'ScheduleReminder',
    data(){
      return {
        title: "",
        type: "Loan Repayment",
        repeatMode: "Once",
        repeatOn: "",
        message: "",
        formHasError: false,
        submitting: false
      }
    },
    watch: {
      repeatMode: function(){
        this.repeatOn = ""
      }
    },
    computed: {
      ...mapState(['creatingReminder']),
      repeatOnChoices: function(){
        const repeatModeChoices = {
          'Once': [], 
          'Monthly': daysOfMonth, 
          'Weekly': weekDays, 
          'Daily': hoursChoices
        };

        return repeatModeChoices[this.repeatMode];
      }
    },
    methods: {
      resetForm(){
        this.title = "";
        this.type = "Loan Repayment";
        this.repeatMode = "Once";
        this.repeatOn = "";
        this.message = "";
        this.submitting = false;
      },
      
      prepareData(){
        const recurring = this.repeatMode !== "Once";
        let type = this.type.replace(/\s+/g, '');
        type = type.charAt(0).toLowerCase() + type.substring(1);
        type += "Reminder";

        let data = {
          title: this.title,
          type,
          mode: recurring ? "repeat" : "oneTime",
          message: this.message
        }

        if(!recurring)
          data.date = this.repeatOn;
        else{
          if(this.repeatMode === "Monthly")
            data.dayOfMonth = this.repeatOn;
          else if(this.repeatMode === "Weekly")
            data.dayOfWeek = weekDays.indexOf(this.repeatOn);
          else if(this.repeatMode === "Daily")
            data.hour = parseInt(this.repeatOn.replace(" : 00", ""));
        }

        return data;
      },

      async createReminder(e){
        e.preventDefault();
        if(!this.type.length || !this.repeatMode.length){
          this.formHasError = true;
          return;
        }
        else
          this.formHasError = false;

        this.$store.dispatch('createReminder', this.prepareData());
      }
    }
  }
</script>
